import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Box, Typography } from '@mui/material';
import { i18n } from '../../translate/i18n';
import { makeStyles } from '@material-ui/core';
import api from "../../services/api";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import GetAppIcon from "@material-ui/icons/GetApp";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  contentBox: {
    padding: "0 8px 8px",
  },
  actionButton: {
    marginTop: 8,
    fontWeight: 600,
    boxShadow: "0 4px 10px rgba(53, 175, 154, 0.2)",
    "&:hover": {
      boxShadow: "0 6px 15px rgba(53, 175, 154, 0.3)",
    },
  },
  uploadLabel: {
    padding: 24,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    marginTop: 12,
    border: `2px dashed ${theme.palette.type === "light" ? "#CBD5E1" : "rgba(255,255,255,0.15)"}`,
    borderRadius: 12,
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: theme.palette.type === "light" ? "#F8FAFC" : "rgba(255,255,255,0.03)",
    color: theme.palette.type === "light" ? "#64748B" : "#94A3B8",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.type === "light" ? "rgba(53,175,154,0.04)" : "rgba(53,175,154,0.08)",
      color: theme.palette.primary.main,
    },
  },
  uploadIcon: {
    fontSize: 32,
    opacity: 0.7,
  },
  uploadText: {
    fontSize: 13,
    fontWeight: 500,
  },
  uploadInput: {
    display: "none",
  },
  statusContainer: {
    padding: 20,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    marginTop: 12,
    border: `2px solid ${theme.palette.type === "light" ? "#E2E8F0" : "rgba(255,255,255,0.1)"}`,
    borderRadius: 12,
    backgroundColor: theme.palette.type === "light" ? "#F8FAFC" : "rgba(255,255,255,0.03)",
  },
  statusMessage: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.type === "light" ? "#475569" : "#CBD5E1",
    textAlign: "center",
    lineHeight: 1.5,
  },
  currentContactText: {
    fontSize: 12,
    color: theme.palette.type === "light" ? "#64748B" : "#94A3B8",
    marginTop: 4,
  },
  closeButton: {
    color: theme.palette.type === "light" ? "#64748B" : "#94A3B8",
    borderColor: theme.palette.type === "light" ? "#E2E8F0" : "rgba(255,255,255,0.12)",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "#F1F5F9" : "rgba(255,255,255,0.05)",
      borderColor: theme.palette.type === "light" ? "#CBD5E1" : "rgba(255,255,255,0.2)",
    },
  },
  buttonRow: {
    display: "flex",
    gap: 8,
    marginTop: 8,
  },
}));

const ContactImportWpModal = ({ isOpen, handleClose, selectedTags, hideNum, userProfile }) => {
  const classes = useStyles();

  const initialContact = { name: "", number: "", error: "" }

  const [contactsToImport, setContactsToImport] = useState([])
  const [statusMessage, setStatusMessage] = useState("")
  const [currentContact, setCurrentContact] = useState(initialContact)

  const handleClosed = () => {
    setContactsToImport([])
    setStatusMessage("")
    setCurrentContact(initialContact)
    handleClose()
  }

  useEffect(() => {
    if (contactsToImport?.length) {
      contactsToImport.map(async (item, index) => {
        setTimeout(async () => {
          try {
            if (index >= contactsToImport?.length - 1) {
              setStatusMessage(`Importação concluída com sucesso!`)
              setContactsToImport([])
              setCurrentContact(initialContact)

              setTimeout(() => {
                handleClosed()
              }, 15000);
            }
            if (index % 5 === 0) {
              setStatusMessage(`Importação em andamento: ${index} de ${contactsToImport?.length}. Não saia desta tela até concluir.`)
            }
            await api.post(`/contactsImport`, {
              name: item.name,
              number: item.number.toString(),
              email: item.email,
            });

            setCurrentContact({ name: item.name, number: item.number, error: "success" })
          } catch (err) {
            setCurrentContact({ name: item.name, number: item.number, error: err })
          }
        }, 330 * index);
      });
    }
  }, [contactsToImport]);

  const handleOnExportContacts = async (model = false) => {
    const allDatas = [];

    let i = 1;
    if (!model) {
      while (i !== 0) {
        const { data } = await api.get("/contacts/", {
          params: { searchParam: "", pageNumber: i, contactTag: JSON.stringify(selectedTags)},
        });
        data.contacts.forEach((element) => {
          const tagsContact = element.tags.map(tag => tag.name).join(', ');
          const contactWithTags = { ...element, tags: tagsContact };
          allDatas.push(contactWithTags);
        });

        const pages = data?.count / 20;
        i++;
        if (i > pages) {
          i = 0;
        }
      }
    } else {
      allDatas.push({
        name: "João",
        number: "5547989845213",
        email: "joao@possoatender.com",
      });
    }
    
    const exportData = allDatas.map((e) => {
      return { name: e.name, number: (hideNum && userProfile === "user" ? e.isGroup ? e.number : e.number.slice(0,-6)+"**-**"+ e.number.slice(-2): e.number), email: e.email, tags: e.tags };
    });
    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(wb, ws, "Contatos");
    XLSX.writeFile(wb, "backup_contatos.xlsx");
  };

  const handleImportChange = (e) => {
    const [file] = e.target.files;
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);
      setContactsToImport(data)
    };
    reader.readAsBinaryString(file);
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={isOpen} onClose={handleClosed}>
      <DialogTitle>{i18n.t("Exportar / Importar contatos")}</DialogTitle>
      <DialogContent>
        <Box className={classes.contentBox}>
          <div className={classes.buttonRow}>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="contained"
              onClick={() => handleOnExportContacts(false)}
              className={classes.actionButton}
              startIcon={<GetAppIcon />}
            >
              {i18n.t("contactImportWpModal.title")}
            </Button>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="outlined"
              onClick={() => handleOnExportContacts(true)}
              startIcon={<DescriptionOutlinedIcon />}
              style={{ marginTop: 8 }}
            >
              {i18n.t("contactImportWpModal.buttons.downloadModel")}
            </Button>
          </div>
          <div>
            {contactsToImport?.length ? (
              <div className={classes.statusContainer}>
                <Typography className={classes.statusMessage}>
                  {statusMessage}
                </Typography>
                {currentContact?.name && (
                  <Typography className={classes.currentContactText}>
                    {`${currentContact?.name} → ${currentContact?.number}`}
                  </Typography>
                )}
              </div>
            ) : (
              <>
                <label className={classes.uploadLabel} htmlFor="contacts">
                  <CloudUploadOutlinedIcon className={classes.uploadIcon} />
                  <span className={classes.uploadText}>
                    {i18n.t("contactImportWpModal.buttons.import")}
                  </span>
                </label>
                <input
                  className={classes.uploadInput}
                  name="contacts"
                  id="contacts"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={handleImportChange}
                />
              </>
            )}
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClosed}
          variant="outlined"
          className={classes.closeButton}
        >
          {i18n.t("contactImportWpModal.buttons.closed")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactImportWpModal;
